module.exports = "/images/taller.jpg?84c639cd13272a6288d597d30fa591e2";